<template>
  <m-dialog ref="rekamanDlg" @save="save" :title="jadwal ? 'Unggah Rekaman: ' + jadwal.nama : ''">
    <v-container>
      <v-form @submit.prevent data-vv-scope="form" lazy-validation>
        <v-card flat class="pa-5 mb-5">
          <v-alert icon="mdi-alert-circle" prominent text type="info">
            Silakan masukkan tautan rekaman kegiatan Anda pada form dibawah ini, tautan berupa tautan gmeet dan akan
            dihitung total durasinya setelah ditekan tombol simpan.
          </v-alert>

          <br />
          <br />
          <div v-for="(item, index) in tautans" :key="index">
            <v-row wrap>
              <v-col cols="12" md="2">
                <v-select
                  dense
                  outlined
                  v-model="tautans[index].tipe_rekaman"
                  :items="['breakout room','main room']"
                  label="Tipe Rekaman"
                  name="tipe"
                  v-validate="'required'"
                  :data-vv-name="'tipe registrasi ' + (index + 1)"
                  :data-vv-as="'tipe registrasi ' + (index + 1)"
                  :error-messages="errors.collect(`form.tipe registrasi ` + (index + 1))"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  :label="`Tautan Rekaman ` + (index + 1)"
                  hint="Masukkan Tautan Rekaman"
                  placeholder="Masukkan Tautan Rekaman"
                  v-model="tautans[index].url_rekaman"
                  :data-vv-name="'tautan ke-' + (index + 1)"
                  :data-vv-as="'tautan ke-' + (index + 1)"
                  v-validate="'required|url'"
                  @keyup.enter="add"
                  :error-messages="errors.collect(`form.tautan ke-` + (index + 1))"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <p class="my-0 py-0 grey--text">Durasi</p>
                {{ toTime(tautans[index].durasi) }}
              </v-col>
              <v-col cols="2">
                <v-btn class="mt-n3" depressed fab color="red" small @click="remove(tautans[index].id, index)">
                  <v-icon color="white">mdi-trash-can</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="8" class="pt-0 mt-0"></v-col>
            <v-col cols="2" class="pt-0 mt-0">
              <p class="my-0 py-0 primary--text font-weight-bold">Total Durasi Main Room</p>
              <span class="font-weight-bold">{{ toTime(totalDurasiMainRoom) }}</span>
              <p class="my-0 py-0 primary--text font-weight-bold">Total Durasi Breakout Room</p>
              <span class="font-weight-bold">{{ toTime(totalDurasiBreakoutRoom) }}</span>
            </v-col>
            <v-col cols="2" class="pt-0 mt-0">
              <v-btn class="mt-n3" depressed fab color="primary" small @click="add()">
                <v-icon color="white">mdi-plus</v-icon>
              </v-btn></v-col
            >
          </v-row>
        </v-card>
      </v-form>
    </v-container>
  </m-dialog>
</template>

<script>
import moment from "moment";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      tempTautan: [],
      tautans: [],
      defTautans: [],
      jadwal: null,
      totalDurasiMainRoom: 0,
      totalDurasiBreakoutRoom: 0,
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.tautans = [];
      this.totalDurasiMainRoom = obj.total_durasi_main_room;
      this.totalDurasiBreakoutRoom = obj.total_durasi_breakout_room;
      this.jadwal = { ...obj };
      if (obj.rekaman.length > 0) {
        var listRekamanSubmodul = [];
        obj.rekaman.forEach(tautan => {
          var rekam = {
            id: tautan.id || 0,
            url_rekaman: tautan.url_rekaman,
            tipe_rekaman: tautan.tipe_rekaman,
            durasi: tautan.durasi
          };
          listRekamanSubmodul.push(rekam);
        });
        this.tautans = [...listRekamanSubmodul];
      }

      let x = this.$refs.rekamanDlg.open().catch(e => {
        this.tautans = [];
        return Promise.reject(e);
      });
      this.$validator.reset();
      return x;
    },
    add() {
      this.tautans.push({ url_rekaman: "", durasi: null });
    },
    remove(id, index) {
      if (typeof id == "undefined") {
        this.tautans.splice(index, 1);
      } else {
        this.$confirm(
          `Tautan berikut telah terdata pada sistem kami.<br>
        <div class="mt-2 title grow text-center">
          Apakah Anda yakin akan menghapus tautan rekaman ini ?
        </div>`
        ).then(() => {
          this.$store
            .dispatch("kelas/hapusRekaman", { instansi_id: this.instansi_id, id: id })
            .then(() => {
              this.tautans.splice(index, 1);
              this.$info("Tautan Rekaman  berhasil dihapus");
              this.$refs.rekamanDlg.resolve();
            })
            .catch(e => e);
        });
      }
    },
    toTime(value) {
      var seconds = moment.duration(value).seconds();
      var minutes = moment.duration(value).minutes();
      var hours = Math.trunc(moment.duration(value).asHours());
      return hours + ":" + minutes + ":" + seconds;
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          var objRekaman = [];
          this.tautans.forEach(tautan => {
            var t = {
              id: tautan.id,
              url_rekaman: tautan.url_rekaman,
              materi_id: this.jadwal.id,
              tipe_rekaman: tautan.tipe_rekaman,
              kelas_id: this.$route.params.kelas_id
            };
            objRekaman.push(t);
          });
          return this.$store
            .dispatch("kelas/unggahRekaman", {
              instansi_id: this.instansi_id,
              obj: objRekaman
            })
            .then(res => {
              this.tautans = [...this.defTautans];
              this.$refs.rekamanDlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
